export default __webpack_public_path__ + "static/media/info-blue@2x.a89a85d0.svg";